//     keymaster.js
//     (c) 2011-2013 Thomas Fuchs
//     keymaster.js may be freely distributed under the MIT license.

;(function(){
	'use strict';

	var global = Function('return this')();

	var k,
		_handlers = {},
		_mods = { 16: false, 18: false, 17: false, 91: false },
		_scope = 'all',
	// modifier keys
		_MODIFIERS = {
			'⇧': 16, shift: 16,
			'⌥': 18, alt: 18, option: 18,
			'⌃': 17, ctrl: 17, control: 17,
			'⌘': 91, command: 91
		},
	// special keys
		_MAP = {
			backspace: 8, tab: 9, clear: 12,
			enter: 13, 'return': 13,
			esc: 27, escape: 27, space: 32,
			left: 37, up: 38,
			right: 39, down: 40,
			del: 46, 'delete': 46,
			home: 36, end: 35,
			pageup: 33, pagedown: 34,
			',': 188, '.': 190, '/': 191,
			'`': 192, '-': 189, '=': 187,
			';': 186, '\'': 222,
			'[': 219, ']': 221, '\\': 220
		},
		code = function(x){
			return _MAP[x] || x.toUpperCase().charCodeAt(0);
		},
		_downKeys = [];

	for(k=1;k<20;k++) _MAP['f'+k] = 111+k;

	// IE doesn't support Array#indexOf, so have a simple replacement
	function index(array, item){
		var i = array.length;
		while(i--) if(array[i]===item) return i;
		return -1;
	}

	// for comparing mods before unassignment
	function compareArray(a1, a2) {
		if (a1.length != a2.length) return false;
		for (var i = 0; i < a1.length; i++) {
			if (a1[i] !== a2[i]) return false;
		}
		return true;
	}

	var modifierMap = {
		16:'shiftKey',
		18:'altKey',
		17:'ctrlKey',
		91:'metaKey'
	};
	function updateModifierKey(event) {
		for(k in _mods) _mods[k] = event[modifierMap[k]];
	};

	// handle keydown event
	function dispatch(event) {
		fixEvent(event);

		var key, handler, k, i, modifiersMatch, scope;
		key = event.keyCode;

		if (index(_downKeys, key) == -1) {
			_downKeys.push(key);
		}

		// if a modifier key, set the key.<modifierkeyname> property to true and return
		if(key == 93 || key == 224) key = 91; // right command on webkit, command on Gecko
		if(key in _mods) {
			_mods[key] = true;
			// 'assignKey' from inside this closure is exported to window.key
			for(k in _MODIFIERS) if(_MODIFIERS[k] == key) assignKey[k] = true;
			return;
		}

		updateModifierKey(event);

		// see if we need to ignore the keypress (filter() can can be overridden)
		// by default ignore key presses if a select, textarea, or input is focused
		if(!assignKey.filter.call(this, event)) return;

		// abort if no potentially matching shortcuts found
		if (!(key in _handlers)) return;

		scope = getScope();

		// for each potential shortcut
		i = _handlers[key].length;
		while (i--) {
			handler = _handlers[key][i];

			// see if it's in the current scope
			if(handler.scope == scope || handler.scope == 'all' || bodyContains(handler.scope)){
				// check if modifiers match if any
				modifiersMatch = handler.mods.length > 0;
				for(k in _mods)
					if((!_mods[k] && index(handler.mods, +k) > -1) ||
						(_mods[k] && index(handler.mods, +k) == -1)) modifiersMatch = false;

				// call the handler and stop the event if neccessary
				if((handler.mods.length == 0 && !_mods[16] && !_mods[18] && !_mods[17] && !_mods[91]) || modifiersMatch){
					if(handler.method(event, handler)===false){
						event.preventDefault();
						event.stopPropagation();
					}

					if (event.isImmediatePropagationStopped()) {
						return true;
					}
				}
			}
		}
	};

	function fixEvent(event) {
		var defaultPrevented = false,
			immediatePropagationStopped = false,
			stopImmediatePropagation = event.stopImmediatePropagation;

		!event.target && (event.target = event.srcElement);

		!event.isDefaultPrevented && (event.isDefaultPrevented = function () {
			return defaultPrevented;
		});

		!event.isImmediatePropagationStopped && (event.isImmediatePropagationStopped = function () {
			return immediatePropagationStopped;
		});

		!event.preventDefault && (event.preventDefault = function () {
			defaultPrevented = true;
			event.returnValue = false;
		});

		!event.stopPropagation && (event.stopPropagation = function () {
			event.cancelBubble = false;
		});

		event.stopImmediatePropagation = function () {
			immediatePropagationStopped = true;
			event.stopPropagation();
			stopImmediatePropagation && stopImmediatePropagation.call(event);
		};
	};

	function bodyContains(el) {
		if (el && el.nodeType === 1) {
			do {
				if (el === document.body) {
					return true;
				}
			} while (el = el.parentNode);
		}

		return false;
	};

	// unset modifier keys on keyup
	function clearModifier(event){
		var key = event.keyCode, k,
			i = index(_downKeys, key);

		// remove key from _downKeys
		if (i >= 0) {
			_downKeys.splice(i, 1);
		}

		if(key == 93 || key == 224) key = 91;
		if(key in _mods) {
			_mods[key] = false;
			for(k in _MODIFIERS) if(_MODIFIERS[k] == key) assignKey[k] = false;
		}
	};

	function resetModifiers() {
		for(k in _mods) _mods[k] = false;
		for(k in _MODIFIERS) assignKey[k] = false;
	};

	// parse and assign shortcut
	function assignKey(key, scope, method){
		var keys, mods, idx;

		keys = getKeys(key);
		if (method === undefined) {
			method = scope;
			scope = 'all';
		}

		// for each shortcut
		for (var i = 0; i < keys.length; i++) {
			// set modifier keys if any
			mods = [];
			key = keys[i].split('+');
			if (key.length > 1){
				mods = getMods(key);
				key = [key[key.length-1]];
			}
			// convert to keycode and...
			key = key[0];
			key = code(key);
			// ...store handler
			if (!(key in _handlers)) _handlers[key] = [];

			idx = findHandleIndex(key, scope, method, mods);
			if (idx > -1) { // exists key listener
				_handlers[key].push(_handlers[key].splice(idx, 1)[0]);
			} else {
				_handlers[key].push({ shortcut: keys[i], scope: scope, method: method, key: keys[i], mods: mods });
			}
		}
	};

	// unbind all handlers for given key in current scope
	function unbindKey(key, scope, method) {
		var multipleKeys, keys,
			mods = [],
			i, idx;

		multipleKeys = getKeys(key);
		if (!scope || typeof scope === 'function') {
			method = scope;
			scope = 'all';
		}

		for (i = 0; i < multipleKeys.length; i++) {
			keys = multipleKeys[i].split('+');

			if (keys.length > 1) {
				mods = getMods(keys);
			}

			key = keys[keys.length - 1];
			key = code(key);

			if (scope === undefined) {
				scope = getScope();
			}

			do {
				idx = findHandleIndex(key, scope, method, mods);
				if (idx > -1) { // remove key listener
					_handlers[key].splice(idx, 1);
				}
			} while (idx != -1);
		}
	};

	function findHandleIndex(key, scope, method, mods) {
		var i, obj, handlers = _handlers[key];

		if (handlers) {
			for (i = 0; i < handlers.length; i++) {
				obj = handlers[i];
				// only clear handlers if correct scope and mods match
				if (obj.scope === scope && (method === undefined || obj.method === method) && compareArray(obj.mods, mods)) {
					return i;
				}
			}
		}

		return -1;
	};


	// Returns true if the key with code 'keyCode' is currently down
	// Converts strings into key codes.
	function isPressed(keyCode) {
		if (typeof(keyCode)=='string') {
			keyCode = code(keyCode);
		}
		return index(_downKeys, keyCode) != -1;
	}

	function getPressedKeyCodes() {
		return _downKeys.slice(0);
	}

	function filter(event){
		var tagName = event.target.tagName;
		// ignore keypressed in any elements that support keyboard data input
		return !(tagName == 'INPUT' || tagName == 'SELECT' || tagName == 'TEXTAREA');
	}

	// initialize key.<modifier> to false
	for(k in _MODIFIERS) assignKey[k] = false;

	// set current scope (default 'all')
	function setScope(scope){ _scope = scope || 'all' };
	function getScope(){ return _scope || 'all' };

	// delete all handlers for a given scope
	function deleteScope(scope){
		var key, handlers, i;

		for (key in _handlers) {
			handlers = _handlers[key];
			for (i = 0; i < handlers.length; ) {
				if (handlers[i].scope === scope) handlers.splice(i, 1);
				else i++;
			}
		}
	};

	// abstract key logic for assign and unassign
	function getKeys(key) {
		var keys;
		key = key.replace(/\s/g, '');
		keys = key.split(',');
		if ((keys[keys.length - 1]) == '') {
			keys[keys.length - 2] += ',';
		}
		return keys;
	}

	// abstract mods logic for assign and unassign
	function getMods(key) {
		var mods = key.slice(0, key.length - 1);
		for (var mi = 0; mi < mods.length; mi++)
			mods[mi] = _MODIFIERS[mods[mi]];
		return mods;
	}

	// cross-browser events
	function addEvent(object, event, method) {
		if (object.addEventListener)
			object.addEventListener(event, method, false);
		else if(object.attachEvent)
			object.attachEvent('on'+event, function(){ method(window.event) });
	};

	// set the handlers globally on document
	addEvent(document, 'keydown', function(event) { // Passing _scope to a callback to ensure it remains the same by execution. Fixes #48
		if (dispatch(event) !== true) {
			var listeners = key.listeners,
				i = 0,
				n = listeners.length;

			for (; i < n; i++) {
				listeners[i](event);

				if (event.isImmediatePropagationStopped()) {
					return true;
				}
			}
		}
	});
	addEvent(document, 'keyup', clearModifier);

	// reset modifiers to false whenever the window is (re)focused.
	addEvent(window, 'focus', resetModifiers);

	// store previously defined key
	var previousKey = global.key;

	// restore previously defined key and return reference to our key object
	function noConflict() {
		var k = global.key;
		global.key = previousKey;
		return k;
	}

	// set window.key and window.key.set/get/deleteScope, and the default filter
	global.key = assignKey;
	global.key.setScope = setScope;
	global.key.getScope = getScope;
	global.key.deleteScope = deleteScope;
	global.key.filter = filter;
	global.key.isPressed = isPressed;
	global.key.getPressedKeyCodes = getPressedKeyCodes;
	global.key.noConflict = noConflict;
	global.key.unbind = unbindKey;

	global.key.on = assignKey;
	global.key.off = unbindKey;
	global.key.listeners = [];

	if(typeof module !== 'undefined') module.exports = assignKey;

	define('toolkit-common/keymaster/keymaster', [], function () { return assignKey; });
})(this);
